"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
DashboardController.$inject = ['$scope', 'api', '$timeout', 'FlickityService', '_product', '_categories', '$location'];
function DashboardController($scope, api, $timeout, FlickityService, _product, _categories, $location) {
    _categories.get().then(function (response) {
        $scope.categories = response;
    });
    FlickityService.instances = [];
    //Glavni slajder
    $scope.flickity_banner = {
        cellAlign: 'left',
        imagesLoaded: true,
        pageDots: false,
        contain: true,
        wrapAround: true,
        autoPlay: 3000,
        arrowShape: {
            x0: 15,
            x1: 55, y1: 40,
            x2: 65, y2: 30,
            x3: 35
        }
    };
    api.get('/b2b/banner/portal').then(function (response) {
        $scope.banners = response.items;
        // Get the element that should hold the slider
        var element = angular.element(document.getElementById('homeBanner'));
        $timeout(function () {
            // Initialize our Flickity instance
            FlickityService.create(element[0], element[0].id, $scope.flickity_banner);
            // FlickityService.resize("productsGroupSlider");
        });
    }, function (error) {
        $scope.errors = error.data;
    });
    //Slajder grupa proizvoda - 1
    $scope.products_slider = {
        cellAlign: 'left',
        imagesLoaded: true,
        prevNextButtons: false,
        pageDots: false,
        freeScroll: true,
        contain: true,
        wrapAround: false
    };
    api.get('/b2b/discount/products/list', { limit: 20 }).then(function (response) {
        $scope.slides = response.items;
        // Get the element that should hold the slider
        var element = angular.element(document.getElementById('productsGroupSlider'));
        $timeout(function () {
            // Initialize our Flickity instance
            FlickityService.create(element[0], element[0].id, $scope.products_slider);
            // FlickityService.resize("productsGroupSlider");
        });
    }, function (error) {
        $scope.errors = error.data;
    });
    api.get('/b2b/newest/products').then(function (response) {
        $scope.slides_newest = response.items;
        // Get the element that should hold the slider
        var element = angular.element(document.getElementById('productsGroupSliderNew'));
        $timeout(function () {
            // Initialize our Flickity instance
            FlickityService.create(element[0], element[0].id, $scope.products_slider);
            // FlickityService.resize("productsGroupSlider");
        });
    }, function (error) {
        $scope.errors = error.data;
    });
    //product-box modal, listanje
    $scope.openModal = function (product, index) {
        //da li je u slides
        var found = false;
        lodash_1.default.each($scope.slides, function (child, index) {
            if (child._id == product._id) {
                found = true;
            }
        });
        if (found) {
            _product.setList($scope.slides);
        }
        else {
            _product.setList($scope.slides_newest);
        }
        $location.search('productView', product._id);
        _product.viewProduct(product, index, null);
    };
}
exports.DashboardController = DashboardController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/controllers/DashboardController.js
// module id = 345
// module chunks = 0